import '@/app/utils/polyfills';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import Routes from '@/app/routes/routes';

ReactDOM.render(
  <Routes />,
  document.getElementById('root') as HTMLElement
);